import {Component, HostListener} from '@angular/core';

import {locale as polish} from './i18n/pl';
import {locale as english} from './i18n/en';
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import {ComponentTitleService} from "../services/componentTitle.service";
import {first} from "rxjs/operators";
import {ReservationDataService} from "../services/reservationData.service";
import {AccountService, UserService} from "../services";
import {User} from "../models";
import {Service} from "../models/service";
import {MatDialog} from "@angular/material/dialog";
import {ServiceNotSelectedDialogComponent} from "./dialog/serviceNotSelectedDialog/serviceNotSelectedDialog.component";
import {CardAlreadyRegisteredDialogComponent} from "./dialog/cardAlreadyRegisteredDialog/cardAlreadyRegisteredDialog.component";
import {CardService} from "../services/card.service";
import {ServiceUnavailableDialogComponent} from "./dialog/serviceUnavailableDialog/serviceUnavailableDialog.component";
import {ConfirmParticipationDialogComponent} from "./dialog/confirmParticipationDialog/confirmParticipationDialog.component";
import {GroupActivityService} from "../calendar/service/groupActivity.service";
import {ActivatedRoute} from "@angular/router";
import {ReservationData} from "../models/reservationData";
import {SelectIncomingTrainingDialogComponent} from "./dialog/selectIncomingTrainingDialog/selectIncomingTrainingDialog.component";
import {GroupActivity} from "../models/groupActivity";
import {GroupActivityCustomer} from "../models/GroupActivityCustomer";
import {Card} from "../models/card";
import {CardNotFoundDialogComponent} from "./dialog/cardNotFoundDialog/cardNotFoundDialog.component";

@Component({
    templateUrl: './training.component.html',
    styleUrls: ['./training.component.scss',]
})
export class TrainingComponent {
    title = 'app-training';
    codeScanner: string[] = [];
    lastKeyup: number;
    loading: boolean = false;
    loadingTrainer: boolean = false;
    trainerNotFound: boolean = false;
    trainerCode: string = '';
    trainer: User;
    selectedService: Service;
    participants: User[] = [];
    view: string = 'preview';
    registeredCards: string[] = [];
    reservation: ReservationData;
    reservations: ReservationData[];

    constructor(
        public dialog: MatDialog,
        private translationLoader: FuseTranslationLoaderService,
        private componentTitleService: ComponentTitleService,
        private reservationDataService: ReservationDataService,
        private userService: UserService,
        private cardService: CardService,
        private route: ActivatedRoute,
        private groupActivityService: GroupActivityService,
        private accountService: AccountService
    ) {
        this.translationLoader.loadTranslations(polish, english);

        componentTitleService.clearTitle();
        componentTitleService.addPart('Trainings');

        this.reservation = this.route.snapshot.data.reservation;

        if (this.reservation) {
            this.trainer = this.reservation.groupActivity.trainer;
        } else {
            this.loadEvents();

            this.loading = true;
            this.accountService.getCurrentAccount().pipe(first())
                .subscribe(
                    (user: User) => {
                        this.trainer = user;
                        this.loading = false;
                        this.loadingTrainer = false;
                    },
                    error => {
                        this.loading = false;
                        this.loadingTrainer = false;
                    });
        }
    }

    loadEvents() {
        let today = new Date();
        let month = new Date(today.setDate(today.getDate()+31));

        this.reservationDataService.getByDate(this.convertDateToString(new Date()) + ' 00:00:00', this.convertDateToString(month) + ' 23:59:59')
            .pipe(first())
            .subscribe((reservations: ReservationData[]) => {
                    this.reservations = [];

                    for (let i = 0; i < reservations.length; i++) {
                        if (reservations[i].completed) {
                            continue;
                        }

                        this.reservations.push(reservations[i]);
                    }

                    if (this.reservations.length > 0) {
                        this.openSelectIncomingTrainingDialog({reservations: this.reservations});
                    }
                },
                error => {

                });
    }

    convertDateToString(date: Date): string {
        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = date.getDate();

        return [date.getFullYear(),
            (mm>9 ? '' : '0') + mm,
            (dd>9 ? '' : '0') + dd
        ].join('-');
    }

    @HostListener('document:keypress', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {
        if (event.key != 'Enter' && event.key != ' ') {
            if (typeof this.lastKeyup !== "undefined" && ((new Date()).getTime() - this.lastKeyup) > 250) {
                this.codeScanner = [];
            }

            this.codeScanner.push(event.key);
            this.lastKeyup = (new Date()).getTime();
        } else if (event.key == 'Enter' && this.codeScanner.length > 2) {
            let code = this.codeScanner.join('');

            if (this.trainerCode.length === 0 && !this.trainer) {
                this.trainerCode = code;
                this.loadingTrainer = true;
                this.trainerNotFound = false;

                this.userService.getByCardNumber(this.trainerCode).pipe(first())
                    .subscribe(
                        (user: User) => {
                            if (user.roles.includes('ROLE_TRAINER') || user.roles.includes('ROLE_WORKER')) {
                                this.trainer = user;
                            } else {
                                this.trainerCode = '';
                                this.trainerNotFound = true;
                            }
                            this.loadingTrainer = false;

                            this.createReservationData(user);
                        },
                        error => {
                            this.loading = false;
                            this.trainer = null;
                            this.loadingTrainer = false;
                            this.trainerNotFound = true;
                            this.trainerCode = '';

                            if (error == 'User not found.') {

                            }
                        });
            } else {
                if (!this.selectedService) {
                    this.openServiceNotSelectedDialog();
                    return;
                }

                if (this.registeredCards.includes(code)) {
                    this.openCardAlreadyRegisteredDialog();
                    return;
                }

                this.loading = true;

                this.cardService.checkCardForService(code, this.selectedService.id).subscribe((response: any) => {
                    this.loading = false;
                    if (response.items.length > 0) {
                        //open confirmation dialog

                        this.openConfirmParticipationDialog(response, code, null);
                        this.loading = false;
                    } else {
                        this.openServiceUnavailableDialog(response);
                    }
                }, err => {
                    this.loading = false;
                });
            }

            this.codeScanner = [];
        }
    }

    selectService(service: Service): void {
        this.selectedService = service;
    }

    openServiceNotSelectedDialog(): void {
        const dialogRef = this.dialog.open(ServiceNotSelectedDialogComponent, {
            panelClass: 'service-not-selected-dialog',
            position: {
                top: '10px',
            }
        });

        dialogRef.afterClosed().subscribe(result => {

        });
    }

    openCardAlreadyRegisteredDialog(): void {
        const dialogRef = this.dialog.open(CardAlreadyRegisteredDialogComponent, {
            panelClass: 'card-already-registered-dialog',
            position: {
                top: '10px',
            }
        });

        dialogRef.afterClosed().subscribe(result => {

        });
    }

    openServiceUnavailableDialog(data: any): void {
        const dialogRef = this.dialog.open(ServiceUnavailableDialogComponent, {
            panelClass: 'service-unavailable-dialog',
            position: {
                top: '10px',
            },
            data: {
                data: data,
            }
        });

        dialogRef.afterClosed().subscribe(result => {

        });
    }

    openCardNotFoundDialog(data: any): void {
        const dialogRef = this.dialog.open(CardNotFoundDialogComponent, {
            panelClass: 'card-not-found-dialog',
            position: {
                top: '10px',
            },
            data: {
                data: data,
            }
        });

        dialogRef.afterClosed().subscribe(result => {

        });
    }

    openSelectIncomingTrainingDialog(data: any): void {
        const dialogRef = this.dialog.open(SelectIncomingTrainingDialogComponent, {
            panelClass: 'select-incoming-training-dialog',
            position: {
                top: '10px',
            },
            width: '650px',
            data: {
                data: data,
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result.status === 'ok') {
                this.loadingTrainer = true;

                this.reservationDataService.getById(result.form.getRawValue().id).subscribe((reservation: ReservationData) => {
                    this.reservation = reservation;
                    this.selectedService = reservation.service;
                    this.loadingTrainer = false;

                    if (this.reservation.groupActivity) {
                        this.trainer = this.reservation.groupActivity.trainer;
                    } else {
                        this.cardService.findCustomerCards(reservation.customer.id).subscribe((cards: Card[]) => {
                            if (cards.length > 0) {
                                this.cardService.checkCardForService(cards[0].cardNumber, this.selectedService.id).subscribe((response: any) => {
                                    this.loading = false;
                                    if (response.items.length > 0) {
                                        reservation.customer.cardNumber = cards[0].cardNumber;
                                        reservation.customer.cardUuid = cards[0].uuid;
                                        this.openConfirmParticipationDialog(reservation.customer, cards[0].cardNumber, reservation.id);
                                        this.loading = false;
                                    } else {
                                        this.openServiceUnavailableDialog(reservation.customer);
                                    }
                                }, err => {
                                    this.loading = false;
                                });
                            } else {
                                this.openCardNotFoundDialog(reservation.customer);
                            }
                        });

                    }

                }, err => {
                    this.loadingTrainer = false;
                });
            }
        });
    }

    openConfirmParticipationDialog(data: any, code: string, reservationDataId): void {
        const dialogRef = this.dialog.open(ConfirmParticipationDialogComponent, {
            panelClass: 'confirm-participation-dialog',
            position: {
                top: '10px',
            },
            data: {
                data: data,
            }
        });

        dialogRef.afterClosed().subscribe(result => {

            if (result.status === 'confirm') {
                this.loading = true;

                if (!this.reservation || this.reservation.groupActivity) {
                    this.cardService.minusItem(data.cardUuid, data.cardNumber, this.selectedService.id).subscribe(minusResult => {
                        this.userService.getByCardNumber(code).pipe(first())
                            .subscribe(
                                (user: User) => {
                                    this.loading = false;
                                    user.cardNumber = code;
                                    this.participants.push(user);
                                    this.registeredCards.push(code);

                                    //@TODO save data to report


                                    if (this.reservation) {
                                        let confirmed = false;
                                        for (let i = 0; i < this.reservation.groupActivity.participants.length; i++) {
                                            if (this.reservation.groupActivity.participants[i].customer.id === user.id) {
                                                confirmed = true;
                                                this.groupActivityService.markAsTookPartIn(this.reservation.groupActivity.participants[i]).subscribe(res => {

                                                });
                                                break;
                                            }
                                        }

                                        if (!confirmed) {
                                            this.groupActivityService.addParticipant(this.reservation, user).subscribe((groupActivity: GroupActivity) => {
                                                for (let i = 0; i < groupActivity.participants.length; i++) {
                                                    if (groupActivity.participants[i].customer.id === user.id) {
                                                        confirmed = true;
                                                        this.groupActivityService.markAsTookPartIn(groupActivity.participants[i]).subscribe(res => {

                                                        });
                                                        break;
                                                    }
                                                }
                                            });
                                        }
                                    }
                                },
                                error => {
                                    this.loading = false;

                                    if (error == 'User not found.') {

                                    }
                                });
                    }, err => {
                        console.log(err);

                        //@TODO error dialog
                    });
                } else {
                    this.cardService.minusItemAndConfirm(data.cardUuid, data.cardNumber, this.selectedService.id, reservationDataId).subscribe(minusResult => {
                        this.userService.getByCardNumber(code).pipe(first())
                            .subscribe(
                                (user: User) => {
                                    this.loading = false;
                                    user.cardNumber = code;
                                    this.participants.push(user);
                                    this.registeredCards.push(code);
                                },
                                error => {
                                    this.loading = false;

                                    if (error == 'User not found.') {

                                    }
                                });
                    }, err => {
                        console.log(err);

                        //@TODO error dialog
                    });
                }
            }
        });
    }

    createReservationData(trainer: User): void {
        let date = new Date();

        this.reservationDataService.create({
            startDate: this._formatDatetime(date, 'yyyy-mm-dd hh:ii:ss'),
            endDate: this._formatDatetime(date, 'yyyy-mm-dd hh:ii:ss'),
            groupActivity: {
                trainer: trainer.id
            }
        }).subscribe((response: ReservationData) => {
            this.reservation = response;
        });

    }

    _formatDatetime(date: Date, format: string) {
        const _padStart = (value: number): string => value.toString().padStart(2, '0');
        return format
            .replace(/yyyy/g, _padStart(date.getFullYear()))
            .replace(/dd/g, _padStart(date.getDate()))
            .replace(/mm/g, _padStart(date.getMonth() + 1))
            .replace(/hh/g, _padStart(date.getHours()))
            .replace(/ii/g, _padStart(date.getMinutes()))
            .replace(/ss/g, _padStart(date.getSeconds()));
    }
}
